import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CCModule } from 'src/app/common.components/cc.module';
import { HomePage } from './home.page';

@NgModule({
    imports: [                
        CommonModule,
        RouterModule,
        CCModule,
    ],
    declarations: [
        HomePage, 
    ],
    exports: [
        HomePage,
    ],
    providers: []
})
export class HomeModule {}
